import { GameType } from "types/Games";

export const getDescription = (
  geo: string | null,
  category: string,
  game: string,
  providers: string | null,
  currentGame: GameType | null,
) => {
  const defaultDescription = `Experience the thrill of online slots at the best ${import.meta.env.VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory"} casino! Play free slots or dive into real money slot games and win big with exciting jackpots today!`;

  const casinoName =
    import.meta.env.VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory";

  if (providers && providers.length) {
    return `🎰 Official slots in ${geo} 💰 Play and win at ${providers} at ${casinoName} Casino`;
  }

  // if (category && !game) {
  //   return `🎰 ${CATEGORIES_FOR_SEO[category]} at ${casinoName} online casino with big bonuses. 💰 Play in slot ${CATEGORIES_FOR_SEO[category]} for free and without registration or for real money. 🤵‍♂️ ${casinoName} Casino`;
  // }

  if (category && currentGame) {
    return `🎰 ${currentGame.name} at ${casinoName} online casino with big bonuses. 💰 Play in slot ${currentGame.name} for free and without registration or for real money. 🤵‍♂️ ${casinoName} Casino`;
  }

  return defaultDescription;
};
